/** Legacy stored value: `'subcategory'` means the shop short description. */
export type EntityCategoryBadgeSource = 'subcategory' | 'category';

export interface ResolveEntityCategoryBadgeOptions {
  override?: string;
  category?: string;
  shortDescription?: string;
  badgeSource?: EntityCategoryBadgeSource;
}

export function resolveEntityCategoryBadge(options: ResolveEntityCategoryBadgeOptions): string {
  const override = options.override?.trim();
  if (override) {
    return override;
  }

  const category = options.category?.trim() ?? '';
  const shortDescription = options.shortDescription?.trim() ?? '';
  const badgeSource = options.badgeSource ?? 'subcategory';

  if (badgeSource === 'category') {
    return category || shortDescription;
  }

  return shortDescription || category;
}
